// Persist the reviewed seller import rows. The import is all-or-nothing: the result carries the
// imported count and any per-row failures, and a single failure imports nothing. Invalidates the
// my-products list on success so the new rows appear there.

import { graphql } from '~/graphql';
import { useGraphqlMutation } from '~/hooks/useGraphqlMutation';

const importSellerInventoryMutation = graphql(`
  mutation ImportSellerInventory($rows: [SellerImportRowInput!]!) {
    importSellerInventory(rows: $rows) {
      total
      imported
      failed {
        rowId
        messages
      }
    }
  }
`);

export function useImportSellerInventory() {
  return useGraphqlMutation(importSellerInventoryMutation, ['my-products']);
}
